<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h2>Upload Test</h2>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <uploader
          @uploaded="fileUploaded"
        ></uploader>

        <br/>

        <uploader
          :src="'https://via.placeholder.com/350x150'"
          @uploaded="fileUploaded"
        ></uploader>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Uploader from '../components/Uploader'

export default {
  components: {
    Uploader
  },

  methods: {
    fileUploaded(res) {
      // console.log('uploaded', res)
    }
  }
}
</script>

<style scoped>
</style>
